// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';
import { APP_ID } from '../../constants.js';
const defaultState = {
  name: APP_ID,
  initComplete: false,
  loading: false,
  error: null
};

export default function appReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.app.ACTION_TYPES.INIT_COMPLETE:
      return { ...state, initComplete: true, loading: false };
    case actions.app.ACTION_TYPES.ERROR:
      return { ...state, error: action.payload, loading: false };
    case actions.app.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    default:
      return state;
  }
}
